module.exports = __webpack_public_path__ + "img/SHOW LIN Beauty Salon.3d38d5c5.svg";